import { render, staticRenderFns } from "./managementMpa.vue?vue&type=template&id=4e6349be&scoped=true&"
import script from "./managementMpa.vue?vue&type=script&lang=js&"
export * from "./managementMpa.vue?vue&type=script&lang=js&"
import style0 from "./managementMpa.vue?vue&type=style&index=0&id=4e6349be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6349be",
  null
  
)

export default component.exports